module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_creva-f7dda1bf4fa057e3900696d286c38534.jpg";